import { render, staticRenderFns } from "./PaymentDetailsPanel.vue?vue&type=template&id=2bf75adc&scoped=true&"
import script from "./PaymentDetailsPanel.vue?vue&type=script&lang=js&"
export * from "./PaymentDetailsPanel.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDetailsPanel.vue?vue&type=style&index=0&id=2bf75adc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf75adc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bf75adc')) {
      api.createRecord('2bf75adc', component.options)
    } else {
      api.reload('2bf75adc', component.options)
    }
    module.hot.accept("./PaymentDetailsPanel.vue?vue&type=template&id=2bf75adc&scoped=true&", function () {
      api.rerender('2bf75adc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/accounting/PaymentDetailsPanel.vue"
export default component.exports